import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden mb-16">
      <div className="absolute inset-0 bg-gradient-to-r from-red-600 via-purple-600 to-pink-600 opacity-90"></div>
      <div className="absolute inset-0 bg-black opacity-20"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="text-center">
          <h1 className="text-6xl md:text-7xl font-black text-white mb-6 tracking-tight">
            Welcome to <span className="text-yellow-300">GamesHub</span>
          </h1>
          <p className="text-xl md:text-2xl text-red-100 mb-8 max-w-3xl mx-auto leading-relaxed">
            Discover the latest games and accessories at unbeatable prices. Your
            ultimate gaming destination awaits.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-2 sm:space-y-0 sm:space-x-4 mb-8">
            <div className="bg-white bg-opacity-20 backdrop-blur-sm rounded-full px-6 py-3">
              <span className="text-white font-semibold">🎮 10,000+ Games</span>
            </div>
            <div className="bg-white bg-opacity-20 backdrop-blur-sm rounded-full px-6 py-3">
              <span className="text-white font-semibold">⭐ 4.9/5 Rating</span>
            </div>
            <div className="bg-white bg-opacity-20 backdrop-blur-sm rounded-full px-6 py-3">
              <span className="text-white font-semibold">🚀 Since 2023</span>
            </div>
          </div>
          <button
            onClick={() => navigate("/products")}
            className="bg-white text-red-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 hover:shadow-lg transition duration-300 transform hover:scale-105"
          >
            Shop Now
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
